import {
  AnEasySmile,
  ConfusedFace,
  FaceWithSpiralEyes,
  Fire,
  HotFace,
  NerdFace,
  ThumbsUp,
  WinkingFace,
  YawningFace,
} from 'assets/icons/reactions-icons'
import { Reactions, ReactionsData } from 'features/videos/service'

export const reactionsData: ReactionsData[] = [
  {
    countName: Reactions.SuperContent,
    icon: <ThumbsUp />,
    reaction: Reactions.SuperContent,
    title: 'Супер контент, спасибо',
    variant: 'primary',
  },
  {
    countName: Reactions.ImprovedUnderstanding,
    icon: <NerdFace />,
    reaction: Reactions.ImprovedUnderstanding,
    title: 'Закрепил материал',
    variant: 'primary',
  },
  {
    countName: Reactions.Normal,
    icon: <WinkingFace />,
    reaction: Reactions.Normal,
    title: 'Норм',
    variant: 'primary',
  },
  {
    countName: Reactions.NothingNew,
    icon: <ConfusedFace />,
    reaction: Reactions.NothingNew,
    title: 'Ничего нового не узнал',
    variant: 'primary',
  },
  {
    countName: Reactions.AllUnderstanding,
    icon: <AnEasySmile />,
    reaction: Reactions.AllUnderstanding,
    title: 'Всё понятно',
    variant: 'primary',
  },
  {
    countName: Reactions.HardUnderstanding,
    icon: <FaceWithSpiralEyes />,
    reaction: Reactions.HardUnderstanding,
    title: 'Сложно для понимания',
    variant: 'primary',
  },
  {
    countName: Reactions.FirePresentation,
    icon: <Fire />,
    reaction: Reactions.FirePresentation,
    title: 'Подача материала огонь',
    variant: 'primary',
  },
  {
    countName: Reactions.FailedPresentation,
    icon: <YawningFace />,
    reaction: Reactions.FailedPresentation,
    title: 'Неудачная подача материала',
    variant: 'primary',
  },
  {
    countName: Reactions.Obsolete,
    icon: <HotFace />,
    reaction: Reactions.Obsolete,
    title: 'Материал устарел',
    variant: 'secondary',
  },
]
